<template>
  <div class="message-packets-component">
    <web-message-packets 
     v-if="integrationType === 'web'"
     :form-data="formData" 
     @previousTab="$emit('previousTab')"
    />

    <cloud-message-packets
     v-else
     :form-data="formData"
     @previousTab="$emit('previousTab')"
    />
  </div>
</template>

<script>

import { useAppStore } from "@/stores/AppStore";
import WebMessagePackets from "./WebMessagePackets";
import CloudMessagePackets from "./CloudMessagePackets";

export default {

  name: 'messagePackets',

  data() {
    return {
      integrationType: undefined
    }
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  components: {
    WebMessagePackets,
    CloudMessagePackets
  },

  watch: {
    'formData.integration.data.type': function (type) {
      this.integrationType = type
    },
  },

  methods: {
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },

    chooseMessagePacket(messagePacket) {
      this.formData.messagePacket.hasSum = messagePacket.mode === 2
      this.formData.messagePacket.showStep = true
      this.formData.messagePacket.data = messagePacket
      this.formData.messagePacket.data.quantity = 1
      this.formData.messagePacket.data.originalPrice = messagePacket.price
      const appStore = useAppStore()
      appStore.showReviewNextButton = true
    }

  },

  mounted() {
    const appStore = useAppStore()
    appStore.showReviewNextButton = false
  }

}

</script>

<style lang="scss" scoped>
$box-color: #000;
</style>